import { RelatedConversationsPanel } from "@/components/messaging/RelatedConversationsPanel";

export function MessagesTab({ id, name }: { id: string; name: string }) {
  return (
    <RelatedConversationsPanel
      resourceType="spv_pool"
      resourceId={id}
      entityLabel={name}
    />
  );
}
